<template>
    <div class="topbar_search">
        <fa :icon="['fal', 'magnifying-glass']" />
    </div>
</template>

<script setup>
</script>

<style scoped>
.topbar_search {
    @apply mr-3 rtl:ml-3 relative cursor-pointer;
}

.topbar_search svg {
    @apply text-2xl text-gray-300 dark:text-gray-darknavtext;
}
</style>
